(function () {
    'use strict';

    a3_cabin_reports.controller('SynchCtrl', SynchCtrl);
    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name SynchCtrl
    * @description 
    *  Manage Sync View
    * @ngInject
    */
    function SynchCtrl($scope, $uibModalInstance, UserFactory, CabinReportLocalEditFactory, SyncAPIService, 
        SyncLogFactory, ReportGuidFactory, CabinReportSyncResultFactory, DataCleanerFactory, MessageFactory, 
        CrewAssessmentFactory, AssessmentSyncResultFactory, SettingsMain, $route, $timeout, MemoFactory, 
        FlightFactory, CabinReportRestoreFactory, CampaignFactory, LuggageComplianceFactory, SaAssessmentSyncResultFactory, SaCrewAssessmentFactory) {

        var IsAssessmentEnabled = SettingsMain.getIsAssessmentEnabled();
        var user = UserFactory.getUser();
        var lastLog = SyncLogFactory.getSyncLog();

        var reportstobesynched = CabinReportLocalEditFactory.getCabinReportLocalEditThatNeedToBeSynched();
        var isSA = false;
        var assessmentstobesynched = [];
        if (user.position == 'SA') {
            if (IsAssessmentEnabled) {
                isSA = true;
                assessmentstobesynched = CrewAssessmentFactory.getAssementsReadyToSend();
            }
        }

        $scope.syncResultsVisible = false;
        $scope.isSynching = false;
        // setup the grid
        $scope.syncTableData = reportstobesynched;
        $scope.IsSA = isSA;
        $scope.IsFA = (user.position == 'FA');
        // get the last sync date
        $scope.isFirstSync = false;
        $scope.isTooOldSync = false;
        $scope.lastSyncDate = '-';
        $scope.syncVersion = '1.3';
        // get the report credits
        $scope.reportCredits = ReportGuidFactory.getRemainingReportGuids();
        // display the number of reports to synch
        $scope.number_of_reports_to_sync = $scope.syncTableData.length;
        $scope.syncAssessmentTableData = assessmentstobesynched;
        $scope.number_of_assessments_to_sync = $scope.syncAssessmentTableData.length;

        $scope.syncSaAssessmentTableData = SaCrewAssessmentFactory.getAssementsReadyToSend();
        $scope.number_of_sa_assessments_to_sync = $scope.syncSaAssessmentTableData.length;

        $scope.lotterySyncResultsData = [];
        $scope.lotterySyncSuccesses = 0;
        $scope.lotterySyncFailures = 0;

        if (lastLog == null) {
            $scope.isFirstSync = true;
        } else {
            if (lastLog.date != null) {
                $scope.lastSyncDate = new Date(lastLog.date).toUTC().toString('dd-MM-yyyy HH:mm') + ' UTC';
                if (Date.today().add(-3).days().toUTC().isAfter(new Date(lastLog.date).toUTC()))
                    $scope.isTooOldSync = true;
            }

            if (lastLog.version != null)
                $scope.syncVersion = lastLog.version;
        }

        $scope.doSynch = doSynch;

        $scope.ok = ok;

        $scope.cancel = cancel;

        $scope.showReportSyncResults = showReportSyncResults;

        $scope.showAssessmentSyncResults = showAssessmentSyncResults;

        $scope.showSaAssessmentSyncResults = showSaAssessmentSyncResults;

        $scope.showLotterySyncResults = showLotterySyncResults;

        $scope.syncResultsOk = syncResultsOk;

        $scope.showSynchError = showSynchError;

        /**
        * Start Synch functionality
        * @memberof SynchCtrl
        */
        function doSynch() {

            //Save reports to indexedDB before the sync
            CabinReportRestoreFactory.backUpReports();

            //waiting for memoIds before we sync
            MemoFactory.getStoredMemosIds(function (memoIdsToSend) {
                // get the user
                var user = UserFactory.getUser();

                // call the remote service for data
                var q = SyncAPIService.doSync(user.aimsId, memoIdsToSend);
                $scope.isSynching = true;

                q.then(function (response) {
                    $scope.isSynching = false;
                    if ($scope.number_of_reports_to_sync > 0) {
                        $scope.showReportSyncResults('synched');
                    } else {
                        $scope.showReportSyncResults('synched-no-send');
                    }
                    $scope.showAssessmentSyncResults();
                    $scope.showSaAssessmentSyncResults();
                    $scope.showLotterySyncResults(response.lotterySyncSummary);
                    DataCleanerFactory.deleteSynchedLocalCabinReports();
                    DataCleanerFactory.deleteOrphanedLocalReports();
                    DataCleanerFactory.deleteOrphanedCustomerEvents();
                    SyncAPIService.updateCabinReportLocalEditFromSynch();
                    FlightFactory.initializeFlights();
                    MemoFactory.markGroundDutiesUnread();
                    $scope.campaigns = CampaignFactory.syncResultFormat(response.data.data.SyncCabinData.Campaigns);
                    
                    $scope.luggageCompliance = LuggageComplianceFactory.syncResultFormat(response.data.data.SyncCabinData.LuggageCompliance);
                });

                q.catch(function (err) {
                    $scope.isSynching = false;

                    if (err.status == -1) {
                        $scope.errorName = "There were problems during the server synchronization. Please try again.";
                    } else if (err.status != 401) {
                        // if an error was encountered display an error message
                        $scope.errorName = "Could not reach the remote server. Please connect to the Internet and try again.";
                    } else {
                        $uibModalInstance.close('');
                    }
                });
            });
        }

        /**
        * show Report Sync Results
        * @memberof SynchCtrl
        */
        function showReportSyncResults() {
            $scope.syncResultsVisible = true;
            // get the sync results
            $scope.syncResultsTableData = CabinReportSyncResultFactory.getCabinReportSyncResultsFromStorage();
            $scope.syncSuccesses = CabinReportSyncResultFactory.getSuccesses($scope.syncResultsTableData);
            $scope.syncFailures = CabinReportSyncResultFactory.getFailures($scope.syncResultsTableData);

            if ($scope.syncResultsTableData != null) {
                $scope.reports_to_sync = $scope.syncResultsTableData.length;
            } else {
                $scope.reports_to_sync = 0;
            }

            if ($scope.syncSuccesses == 1) {
                $scope.sync_successes_descr = 'Cabin Report was';
            } else {
                $scope.sync_successes_descr = 'Cabin Reports were';
            }

            if ($scope.syncFailures == 1) {
                $scope.sync_failures_descr = 'Cabin Report was';
            } else {
                $scope.sync_failures_descr = 'Cabin Reports were';
            }
            $scope.unreadMessages = MessageFactory.getCountOfUnreadMessages();
        }

        /**
        * show Assessment Sync Results
        * @memberof SynchCtrl
        */
        function showAssessmentSyncResults() {
            $scope.syncResultsVisible = true;
            // get the sync results
            $scope.syncAssessmentResultsTableData = AssessmentSyncResultFactory.getAssessmentSyncResultsFromStorage();
            $scope.syncAssessmentSuccesses = AssessmentSyncResultFactory.getSuccesses($scope.syncAssessmentResultsTableData);
            $scope.syncAssessmentFailures = AssessmentSyncResultFactory.getFailures($scope.syncAssessmentResultsTableData);


            if ($scope.syncAssessmentResultsTableData != null) {
                $scope.assessments_to_sync = $scope.syncAssessmentResultsTableData.length;
            } else {
                $scope.assessments_to_sync = 0;
            }

            if ($scope.syncAssessmentSuccesses == 1) {
                $scope.sync_assessment_successes_descr = 'Crew Feedback was';
            } else {
                $scope.sync_assessment_successes_descr = 'Crew Feedbacks were';
            }

            if ($scope.syncAssessmentFailures == 1) {
                $scope.sync_assessment_failures_descr = 'Crew Feedbacks was';
            } else {
                $scope.sync_assessment_failures_descr = 'Crew Feedbacks were';
            }
        }

        /**
        * show SA Assessment/Feedbacks Sync Results
        * @memberof SynchCtrl
        */
        function showSaAssessmentSyncResults() {
            $scope.syncResultsVisible = true;
            // get the sync results
            $scope.syncSaAssessmentResultsTableData = SaAssessmentSyncResultFactory.getAssessmentSyncResultsFromStorage();
            $scope.syncSaAssessmentSuccesses = SaAssessmentSyncResultFactory.getSuccesses($scope.syncSaAssessmentResultsTableData);
            $scope.syncSaAssessmentFailures = SaAssessmentSyncResultFactory.getFailures($scope.syncSaAssessmentResultsTableData);

            if ($scope.syncSaAssessmentResultsTableData != null) {
                $scope.sa_assessments_to_sync = $scope.syncSaAssessmentResultsTableData.length;
            } else {
                $scope.sa_assessments_to_sync = 0;
            }

            if ($scope.syncAssessmentSuccesses == 1) {
                $scope.sync_assessment_successes_descr = 'Crew Feedback was';
            } else {
                $scope.sync_assessment_successes_descr = 'Crew Feedbacks were';
            }

            if ($scope.syncAssessmentFailures == 1) {
                $scope.sync_assessment_failures_descr = 'Crew Feedbacks was';
            } else {
                $scope.sync_assessment_failures_descr = 'Crew Feedbacks were';
            }
        }

        /**
        * Show Lottery Sync Results
        * @memberof SynchCtrl
        */
        function showLotterySyncResults(summary) {
            $scope.syncResultsVisible = true;
            $scope.lotterySyncResultsData = summary || [];
            $scope.lotterySyncSuccesses = $scope.lotterySyncResultsData.filter(function (r) {
                return r.Success || r.IsDuplicate;
            }).length;
            $scope.lotterySyncFailures = $scope.lotterySyncResultsData.filter(function (r) {
                return !r.Success && !r.IsDuplicate;
            }).length;
        }

        /**
        * Close sync Result modal and update cache.
        * @memberof SynchCtrl
        */
        function syncResultsOk() {
            $uibModalInstance.close('synched');
            $route.reload();
            // get cache
        }

        /**
        * Show submision sync error
        * @memberof SynchCtrl
        */
        function showSynchError(message) {
            bootbox.dialog({
                message: message,
                title: "<strong>Submission error<strong>",
                buttons: {
                    cancel: {
                        label: "OK",
                        className: "btn-default",
                        callback: function () { }
                    }
                }
            });
        }

        /**
        * Close  modal and update cache.
        * @memberof SynchCtrl
        */
        function cancel() {
            $uibModalInstance.close('cancel');
            // get cache
        }

        /**
        * Close  modal
        * @memberof SynchCtrl
        */
        function ok() {
            $uibModalInstance.close('');
        }

    }

})();